import { emailTemplateSchema } from "@redotech/redo-marketing-templates-common/email-template";
import * as z from "zod";

const templateSource = z.union([
  z.object({ templateId: z.string() }),
  z.object({ savedTemplateId: z.string() }),
  z.object({ template: emailTemplateSchema }),
  z.object({ originTemplateId: z.string() }),
]);

export const previewEmailTemplate = {
  name: "previewEmailTemplate" as const,
  input: z.intersection(
    templateSource,
    z.object({
      /**
       * When set, render the preview from this recent event's data instead of
       * the synthetic sample. Ignored if the event can't be resolved.
       */
      eventId: z.string().optional(),
    }),
  ),
  output: z.string(),
};
